// extracted by mini-css-extract-plugin
export default {"form":"ServerForm_form__6vqWV","hint":"ServerForm_hint__2dJwg","formGroup":"ServerForm_formGroup__WzD06"};